<template>
    <draggable
      v-model="internalUsuarios"
      item-key="id"
      group="vendedores"
      :move="podeMover"
      @start="onDragStart"
      @end="onDragEnd"
    >
      <template #item="{ element, index }">
        <div class="accordion mb-2" v-if="element && element.id">
          <div class="accordion-item">
            <button
              class="accordion-button collapsed card-table-txt"
              data-bs-toggle="collapse"
              :data-bs-target="'#row-' + element.id"
              :class="[
                'table-linha',
                'draggable-row',  
                getStatusClass(element),
                { 'table-active': isDragging && currentDrag === element.id }
              ]"
            >
              {{ index + 1 + ")" }}

              <!-- Ícone de arraste -->
              {{element.vendedor.username }}
            </button>
            <div :id="'row-' + element.id" class="accordion-collapse collapse">
              <div class="accordion-body">
                <div class="d-flex align-items-center justify-content-between">
                   <p class="mb-0">
                    <strong>Tipo Vendedor:</strong>
                     {{ element.vendedor.tipo_vend[0]?.tipo_vendedor === 1 ? 'Novo' : 
                element.vendedor.tipo_vend[0]?.tipo_vendedor === 2 ? 'Usado' : 
                element.vendedor.tipo_vend[0]?.tipo_vendedor === 3 ? 'Ambos' : 
                'Não definido' }}
                 </p>
                  <p class="mb-0">
                    <strong>Posição Pausa:</strong>
                    {{ getPosicaoPausa(element) }}
                  </p>
                  <button
                    v-if="element.liberado_gerente === 3"
                    type="button"
                    class="btn-desk"
                    @click.stop="despausar_vendedor(element)"
                    title="Retornar para fila"
                  >
                    <i class="bi bi-play-circle"></i>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn-desk"
                    @click.stop="pausar_vendedor(element)"
                    title="Pausar vendedor"
                  >
                    <i class="bi bi-pause-circle"></i>
                  </button>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </draggable>
</template>

<script>
import { ref, watch } from "vue";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  props: {
    usuarios: {
      type: Array,
      required: true,
      validator: (value) =>
        Array.isArray(value) && value.every((item) => "id" in item),
    },
  },
  emits: [
    "update:usuarios",
    "reordenado",
    "pausar",
    "despausar",
    "reordenacao-bloqueada",
  ],
  setup(props, { emit }) {
    const internalUsuarios = ref([...props.usuarios]);
    const isDragging = ref(false);
    const currentDrag = ref(null);
    const ordemAntesDrag = ref([]);
    const movimentoBloqueado = ref(false);
    const vendedorMovidoId = ref(null);

    watch(
      () => props.usuarios,
      (newVal) => {
        internalUsuarios.value = [...newVal];
      }
    );

    const onDragStart = (event) => {
      ordemAntesDrag.value = internalUsuarios.value.map((item) => item.id);
      movimentoBloqueado.value = false;
      vendedorMovidoId.value = internalUsuarios.value[event.oldIndex]?.id || null;
    };

    const onDragEnd = () => {
      isDragging.value = false;
      currentDrag.value = null;
      const ordemDepoisDrag = internalUsuarios.value.map((item) => item.id);
      const ordemMudou =
        ordemAntesDrag.value.join("|") !== ordemDepoisDrag.join("|");

      if (movimentoBloqueado.value || !ordemMudou) {
        movimentoBloqueado.value = false;
        vendedorMovidoId.value = null;
        return;
      }

      emit("update:usuarios", internalUsuarios.value);
      emit("reordenado", internalUsuarios.value, vendedorMovidoId.value);
      vendedorMovidoId.value = null;
    };

    const podeMover = (event) => {
      const podeReordenar = event.draggedContext.element?.liberado_gerente !== 3;
      if (!podeReordenar) {
        movimentoBloqueado.value = true;
        emit("reordenacao-bloqueada");
      }
      return podeReordenar;
    };

    const getPosicaoPausa = (item) => {
      if (item?.liberado_gerente === 3) {
        const pausados = internalUsuarios.value.filter((vendedor) => {
          return vendedor.liberado_gerente === 3;
        });
        const posicao = pausados.findIndex((vendedor) => vendedor.id === item.id);
        return posicao === -1 ? item.ordem_anterior || "-" : posicao + 1;
      }

      return item?.ordem_anterior || "-";
    };

    const getStatusClass = (item) => {
      if (!item?.status_vendedor) return "";
      return {
        "table-disponivel": item.status_vendedor.includes("Disponível"),
        "table-indisponivel": item.status_vendedor.includes("Indisponível"),
        "table-em-atendimento": item.status_vendedor.includes("Bloqueado"),
      };
    };

    const editItem = (item) => {
      console.log("Editar:", item);
    };

    const deleteItem = (id) => {
      console.log("Deletar:", id);
    };

    const pausar_vendedor = (vendedor) => {
      emit("pausar", vendedor);
    };

    const despausar_vendedor = (vendedor) => {
      emit("despausar", vendedor);
    };

    return {
      internalUsuarios,
      isDragging,
      currentDrag,
      onDragStart,
      onDragEnd,
      podeMover,
      getPosicaoPausa,
      getStatusClass,
      editItem,
      deleteItem,
      pausar_vendedor,
      despausar_vendedor,
    };
  },
};
</script>

<style scoped>
.sortable-ghost {
  opacity: 0.7;
  background: #e9ecef;
}

.sortable-chosen {
  background-color: #f8f9fa;
}

.table-active {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

/* Estilo para toda a linha arrastável */
.draggable-row {
  cursor: move;
  user-select: none;
}

/* Opcional: destaque ao arrastar */
.draggable-row:active {
  cursor: grabbing;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.table-linha {
  transition: all 0.3s ease;
}

/* Prevenir seleção de texto durante o arraste */
.table-linha * {
  user-select: none;
  -webkit-user-select: none;
}
</style>
